import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionService {
  private readonly keys = {
    authToken: 'authToken',
    authTokenPainel: 'authTokenPainel',
    authTokenExpiration: 'tempo_authToken',
    ehProdutor: 'ehProduto',
    ultimaUrl: 'ultimaUrl',
    stravaRedirectUrl: 'urlRedStravaCredenciamento'
  };

  setAuthToken(token: string, expirationTimestamp: number) {
    this.setItem(this.keys.authToken, token);
    this.setItem(this.keys.authTokenExpiration, expirationTimestamp.toString());
  }

  getAuthToken(): string {
    return this.getItem(this.keys.authToken);
  }

  clearAuthToken() {
    this.removeItem(this.keys.authToken);
    this.removeItem(this.keys.authTokenExpiration);
  }

  getAuthTokenExpiration(): number | null {
    const value = this.getItem(this.keys.authTokenExpiration);
    return value ? Number(value) : null;
  }

  setPainelToken(token: string) {
    this.setItem(this.keys.authTokenPainel, token);
  }

  getPainelToken(): string {
    return this.getItem(this.keys.authTokenPainel);
  }

  clearPainelToken() {
    this.removeItem(this.keys.authTokenPainel);
  }

  setEhProdutor(value: boolean) {
    this.setItem(this.keys.ehProdutor, String(value));
  }

  getEhProdutor(): boolean {
    return this.getItem(this.keys.ehProdutor) === 'true';
  }

  clearEhProdutor() {
    this.removeItem(this.keys.ehProdutor);
  }

  setUltimaUrl(url: string) {
    this.setItem(this.keys.ultimaUrl, url);
  }

  getUltimaUrl(): string {
    return this.getItem(this.keys.ultimaUrl);
  }

  setStravaRedirectUrl(url: string) {
    this.setItem(this.keys.stravaRedirectUrl, url);
  }

  getStravaRedirectUrl(): string {
    return this.getItem(this.keys.stravaRedirectUrl);
  }

  clearStravaRedirectUrl() {
    this.removeItem(this.keys.stravaRedirectUrl);
  }

  private setItem(key: string, value: string) {
    try {
      localStorage.setItem(key, value);
    } catch {
      return;
    }
  }

  private getItem(key: string): string {
    try {
      return localStorage.getItem(key) ?? '';
    } catch {
      return '';
    }
  }

  private removeItem(key: string) {
    try {
      localStorage.removeItem(key);
    } catch {
      return;
    }
  }
}
